export default "/app/global-wrapper-client/static/e0e54018ce2eee11eb5bbb8d05c51be5.woff";